import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class ChargeUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id: number = parseInt(this.component.props.params.id, 10);

    this.component.props.dispatch({
      type: Constants.GLOBAL_CHARGE_UPDATE_CLEAR
    });

    this.component.initializePage(id);
  }
}

export default new ChargeUpdateWillMount();
